import { useSearchParams } from 'react-router-dom';

import { ButtonBase, useMediaQuery, useTheme } from '@mui/material';

import { useProductDemoMode } from '~modules/product-demo/hooks/use-product-demo-mode';
import { PRODUCT_DEMO_BANNER_ID } from '~modules/product-demo/product-demo-anchors';

import { AppIcon } from '~components/shared/app-icon/app-icon';
import { AppTypography } from '~components/ui/typography/app-typography';

import { useMobileMenu } from '~hooks/use-mobile-menu';

import { ReactComponent as IconShow } from '~assets/icons/icon-show.svg';

export const ProductDemoMobileBadge = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { isMenuOpen } = useMobileMenu();
  const { isDemoMode } = useProductDemoMode();
  const [, setSearchParams] = useSearchParams();

  if (!isDemoMode || isMenuOpen) return null;

  const handleClick = () => {
    setSearchParams(
      (current) => {
        const next = new URLSearchParams(current);

        next.set('scrollTo', PRODUCT_DEMO_BANNER_ID);
        next.set('pulse', PRODUCT_DEMO_BANNER_ID);
        next.set('cleanup', 'true');

        return next;
      },
      { replace: true },
    );
  };

  return (
    <ButtonBase
      aria-label="Перейти до банера демо-режиму"
      onClick={handleClick}
      sx={{
        position: 'fixed',
        right: '16px',
        bottom: isMobile
          ? 'calc(74px + 10px + env(safe-area-inset-bottom))'
          : '16px',
        zIndex: 10,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1.35,
        py: 0.8,
        borderRadius: '999px',
        color: '#FFFFFF',
        backgroundColor: 'primaryTokens.100',
        boxShadow:
          '0 10px 24px rgba(0, 106, 255, 0.24), 0 2px 8px rgba(0, 53, 128, 0.16)',
        border: '1px solid',
        borderColor: 'primaryTokens.75',
        WebkitTapHighlightColor: 'transparent',
      }}
    >
      <AppIcon component={IconShow} size={17} color="#FFFFFF" />
      <AppTypography
        size="body-caption"
        weight="bold"
        sx={{ color: 'inherit', lineHeight: 1 }}
      >
        Демо
      </AppTypography>
    </ButtonBase>
  );
};
